/**
 * Mixin for handling contract ending functionality
 * Used in ContractsRecordEndContractModal and ContractsRecordConfirmStopModal
 */

export default {
    methods: {
        /**
         * Show credit invoice modal with products from response
         * @param {Object|Array} payload - Products or object with products and endDate
         */
        showCreditInvoiceModal(payload) {
            if (Array.isArray(payload)) {
                // Direct array of products (old flow)
                this.depositProducts = payload
                this.selectedEndDate = null
                this.creditExtraProducts = []
            } else if (payload && typeof payload === 'object') {
                // Object with products and endDate from end-contract flow
                const allProducts = payload.products || []

                // Separate deposit products from prorated products
                this.depositProducts = allProducts.filter(p => parseFloat(p.deposit || 0) > 0)
                this.creditExtraProducts = allProducts.filter(p => parseFloat(p.price || 0) > 0 && parseFloat(p.deposit || 0) === 0)
                this.selectedEndDate = payload.endDate || null

                console.log('End-contract credit modal:', {
                    allProducts,
                    depositProducts: this.depositProducts,
                    creditExtraProducts: this.creditExtraProducts,
                    endDate: this.selectedEndDate
                })
            }

            // Clean up URL to prevent end-contract modal from reopening
            if (this.$route.query.cancel) {
                this.$router.replace({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: { ...this.$route.query, cancel: undefined }
                })
            }

            // Emit event for parent component to handle
            this.$emit('showCreditInvoiceModal', {
                products: [...(this.depositProducts || []), ...(this.creditExtraProducts || [])],
                endDate: this.selectedEndDate
            })
        },

        /**
         * Close the end contract modal
         */
        closeEndContractModal() {
            this.$emit('closeEndContractModal')

            // Clean up URL parameters to prevent modal reopening
            if (this.$route.query.cancel) {
                this.$router.replace({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: { ...this.$route.query, cancel: undefined }
                })
            }
        },

                /**
         * Process response from contract ending API call
         * @param {Object} response - API response
         * @param {String} successMessage - Message to show on success
         */
        processContractEndingResponse(response, successMessage) {
            // Handle string responses
            if (typeof response.data === 'string') {
                if (response.data === 'contract-already-finalized') {
                    this.showError('Contract is al afgesloten!')
                    this.closeEndContractModal()
                    return false
                }

                this.showMessage(successMessage || 'Contract is aangepast!')
                this.$emit('reload')

                if (response.data === 'success') {
                    if (this.hasAccess) {
                        this.showAccessMessage = true
                    } else {
                        this.closeEndContractModal()
                    }
                    return true
                }
            }

            // Get products from response
            // The response can be either a direct array, an array inside response.data,
            // or an object with original property containing the array
            let responseProducts = [];
            if (Array.isArray(response.data)) {
                responseProducts = response.data;
            } else if (response.data && response.data.original && Array.isArray(response.data.original)) {
                responseProducts = response.data.original;
            }

            // If there are deposits or proration lines, show the credit invoice modal
            const hasDeposits = responseProducts.length > 0;
            const hasProration = this.endPreview && this.endPreview.lines && this.endPreview.lines.length > 0;

            if (hasDeposits || hasProration) {
                // Use the calculated proration data instead of raw contract products
                const creditProducts = [];

                // Add deposit products (original contract products with deposits)
                if (hasDeposits) {
                    responseProducts.filter(p => parseFloat(p.deposit || 0) > 0).forEach(product => {
                        creditProducts.push(product);
                    });
                }

                // Add proration lines from endPreview (backend returns empty lines for future periods)
                if (this.endPreview && this.endPreview.lines) {
                    this.endPreview.lines.forEach(line => {
                        const creditProduct = {
                            id: line.product,
                            product: line.product,
                            name: `${line.name} (${line.remainingDays} ${line.remainingDays === 1 ? 'dag' : 'dagen'})`,
                            type: 'box',
                            amount: 1,
                            once: 1,
                            btw: '0.00',
                            deposit: 0,
                            price: line.creditAmount,
                            totalType: 'price'
                        };

                        // Only add invoice ID if an actual invoice exists (not for future periods)
                        if (this.endPreview && this.endPreview.invoice && this.endPreview.invoice.id) {
                            creditProduct.invoice = this.endPreview.invoice.id;
                        }

                        creditProducts.push(creditProduct);
                    });
                }

                // Show success message
                this.showMessage(successMessage || 'Contract is aangepast!');
                this.$emit('reload');

                // Show credit invoice modal
                this.showCreditInvoiceModal({
                    products: creditProducts,
                    endDate: this.endDateString || this.selectedEndDate
                });

                if (this.hasAccess) {
                    this.showAccessMessage = true;
                } else {
                    setTimeout(() => this.closeEndContractModal(), 500);
                }
                return true;
            } else {
                // No products to credit, just show success message
                this.showMessage(successMessage || 'Contract is aangepast!');
                this.$emit('reload');

                if (this.hasAccess) {
                    this.showAccessMessage = true;
                } else {
                    this.closeEndContractModal();
                }
                return true;
            }
        }
    }
}
